import { SegmentProduct } from './events';

type CIO = {
  track: (event: string, properties?: Record<string, unknown>) => void;
};

export class CustomerIO {
  private static getCio(): CIO | undefined {
    return (window as any)._cio as CIO | undefined;
  }

  private static EVENTS = {
    ADDED_ITEM_TO_CART: 'Added Item To Cart',
    SHIPPING_PAGE_CONTINUE: 'Shipping page > Continue',
    STARTED_CHECKOUT: 'Started Checkout',
  };

  static trackShippingPageContinue(products: SegmentProduct[]): void {
    this.getCio()?.track(CustomerIO.EVENTS.SHIPPING_PAGE_CONTINUE, { products });
  }

  static trackAddedItemToCart(productName: string, productColor?: string): void {
    this.getCio()?.track(CustomerIO.EVENTS.ADDED_ITEM_TO_CART, {
      product_name: productName,
      product_color: productColor,
    });
  }

  static trackStartedCheckout(products: SegmentProduct[]) {
    this.getCio()?.track(CustomerIO.EVENTS.STARTED_CHECKOUT, { products });
  }
}
